<main class="filters">
  <h2 class="filters-title">Manage types</h2>

  <div class="filters-grid">
    <app-fax-rule-list
      [items]="rules"
      [folders]="folders"
      [isLoading]="isRulesLoading"
      (createClick)="openCreateRuleModal()"
      (editClick)="openEditRuleModal($event)"
      (deleteClick)="openDeleteRuleModal($event)"
    ></app-fax-rule-list>

    <app-fax-folder-list
      [items]="folders"
      [isLoading]="isFoldersLoading"
      (createClick)="createFolder($event)"
      (deleteClick)="openDeleteFolderModal($event)"
    ></app-fax-folder-list>
  </div>
</main>

<app-create-fax-rule-modal
  [folders]="folders"
  [ruleToEdit]="ruleToEdit"
  (submit)="createRule($event)"
></app-create-fax-rule-modal>

<app-delete-fax-folder-modal
  [folderName]="selectedFolderName"
  (submit)="deleteFolder()"
></app-delete-fax-folder-modal>

<app-delete-fax-rule-modal
  [rule]="selectedRule"
  [folders]="folders"
  (submit)="deleteRule()"
></app-delete-fax-rule-modal>
